import { createAction } from '@reduxjs/toolkit';

import { logError } from 'src/utils/logger';
import * as editorPrepare from './editor.prepare';

export const setActivePage = createAction('editor/set_active_page');

export const setZoom = createAction('editor/set_zoom', (payload) => {
  if (typeof payload !== 'number' || Number.isNaN(payload)) {
    logError('editor/set_zoom')(new Error('Zoom must be a number'));
  }

  return { payload };
});

export const setTextLinks = createAction('editor/set_text_links');
export const setTextLinksFromMetadata = createAction('editor/set_text_links_from_metadata');
export const addTextLink = createAction('editor/add_text_link');
export const removeTextLink = createAction('editor/remove_text_link');

export const setPagesOrder = createAction('editor/set_pages_order');
export const setCanvasRelativeSize = createAction('editor/set_canvas_relative_size');
export const setCurrentLayer = createAction('editor/set_current_layer');

export const setHeaderSize = createAction('editor/set_header_size', editorPrepare.setHeaderFooterSize);
export const setFooterSize = createAction('editor/set_footer_size', editorPrepare.setHeaderFooterSize);
